import React from "react";

export const VideoBird = (props) => {
  return (
    <div
      id="about"
      style={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#fff",
        height: "80vh",
        width: "100vw",
      }}
    >
      {/* Estilos embebidos para media queries */}
      <style>
        {`
          @media (max-width: 991px) {
            .video-bird {
              width: 100vw !important;
              left: 0 !important;
              transform: none !important;
            }
          }
        `}
      </style>

      {/* Video con clase para manejar el comportamiento responsivo */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="video-bird"
        style={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "50vw",
          height: "80vh",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source src="/img/videopajaro.mp4" type="video/mp4" />
        Tu navegador no soporta videos.
      </video>

      {/* Texto superpuesto centrado */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "0 2rem",
          backgroundColor: "rgba(255,255,255, .5)"
        }}
      >
        <h2 style={{ color: "#0A3A2C", fontSize: "2rem", marginBottom: "1rem" }}>
          {props.data ? props.data.title : "loading..."}
        </h2>
        <p style={{ fontSize: "22px", color: "#0A3A2C", maxWidth: "800px" }}>
          {props.data ? props.data.text : "loading..."}
        </p>
      </div>
    </div>
  );
};
